import { render } from "./DeletedBanners.vue?vue&type=template&id=51819e10&scoped=true"
import script from "./DeletedBanners.vue?vue&type=script&lang=js"
export * from "./DeletedBanners.vue?vue&type=script&lang=js"

import "./DeletedBanners.vue?vue&type=style&index=0&id=51819e10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51819e10"]])

export default __exports__